import styled from 'styled-components';
import { BasketPaymentDetailsStyled } from '../../BasketPaymentDetailsStyled';
import { rem } from 'polished';

export const BasketPaymentDetailsOV = styled(BasketPaymentDetailsStyled)`
    .titleWrapper {
        .title {
            font-size: ${({ theme }) => theme.fontSizes.h3};
        }
    }

    .description {
        font-family: ${({ theme }) => theme.fonts.fontSecondary};
    }

    .sections {
        .inner {
            .description {
                font-family: ${({ theme }) => theme.fonts.fontSecondary};
            }
        }
    }

    .cashSummary {
        p {
            font-family: ${({ theme }) => theme.fonts.fontSecondary};
        }
    }

    .financeSummary {
        font-family: ${({ theme }) => theme.fonts.fontSecondary};
        .price,
        .financeTitle {
            font-size: ${rem('20px')};
        }

        .monthlyPaymentSummary {
            .price {
                font-weight: normal !important;
            }
        }

        .personalizeButton {
            color: ${({ theme }) => theme.colors.primary};
            border-color: ${({ theme }) => theme.colors.primary};
            font-size: ${({ theme }) => theme.fontSizes.h5};
        }
    }

    .needHand {
        &_label {
            font-size: ${rem(16)};
            color: ${({ theme }) => theme.colors.black2};
        }

        &_modalButton {
            font-size: ${rem(16)};
            color: ${({ theme }) => theme.colors.black2};

            svg {
                path {
                    fill: ${({ theme }) => theme.colors.black2};
                }
            }

            &:hover,
            &:focus-visible {
                color: ${({ theme }) => theme.colors.primary};

                svg {
                    path {
                        fill: ${({ theme }) => theme.colors.primary};
                    }
                }
            }
        }

        &_phone {
            font-size: ${rem(16)};
            color: ${({ theme }) => theme.colors.black2};

            &:hover,
            &:focus-visible {
                color: ${({ theme }) => theme.colors.primary};
            }
        }
    }

    .legalText {
        p {
            color: ${({ theme }) => theme.colors.grey1};
            font-size: ${({ theme }) => theme.fontSizes.h6};
        }
    }
`;
